// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_LEE","cls2":"ResearchInterestTags-cls2_AHg ResearchInterestTags-cls1_LEE"};